import React from 'react'
import { IoMdClose } from "react-icons/io";
import { useNavigate } from 'react-router-dom';


const CreateAccountModal = ({ setCreateAccount }) => {
    const navigate = useNavigate()

    const hideModal = (event) => {
        const modal = document.getElementById('modal');
        // Check if the clicked element is outside of the modal
        if (event.target !== modal && !modal.contains(event.target)) {
            setCreateAccount(null)// Call the function to close the modal
        }
    }
    return (
        <div>
            <div
                onClick={hideModal}
                className="  cursor-pointer  h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0  z-[110] outline-none focus:outline-none scrollbar-hide"
            >
                <div id='modal' className="relative my-6 mx-[2%] sm:mx-0  ">
                    {/*content*/}
                    <div className=" cursor-default  fixed relative rounded-t-[30px] rounded-[30px] border-0 shadow-lg  flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className='w-[327px] h-[357px] md:w-[500px] md:h-[300px] pt-[27px] px-[42px] flex flex-col gap-[30px]'>
                            <div className='w-full flex items-end justify-end'>
                                <IoMdClose onClick={() => setCreateAccount(null)} className=' cursor-pointer w-[25px] h-[25px]' />
                            </div>
                            <div className='w-full flex flex-col gap-[48px] items-center justify-center'>
                                <div className='w-full flex flex-col gap-[3px] items-center justify-center text-center'>
                                    <h1 className=' font-black text-[16px] leading-[21.6px] md:text-[24px] md:leading-[32.4px]'>Create an account</h1>
                                    <p className=' font-medium text-[14px] text-ravash leading-[18.9px]'>You will need an account to perform this action</p>
                                </div>
                                <div className='w-full flex flex-col md:flex-row gap-[13px] items-center justify-center px-[32px]'>
                                    <button onClick={()=>navigate('/login')} className=' w-full h-[50px] rounded-[80px] bg-ravblue flex items-center text-center justify-center font-bold text-[16px] text-white leading-[21.6px]'>Login</button>
                                    <button onClick={()=>navigate('/signup')} className=' w-full h-[50px] rounded-[80px] bg-white border-solid border-[1px] border-[#AAAAAA] flex items-center text-center justify-center font-bold text-[16px] text-[#707070] leading-[21.6px]'>Signup</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className=" opacity-60 xm:opacity-70 fixed inset-0 z-[100] bg-black"></div>
        </div>
    )
}

export default CreateAccountModal
